module.exports = __webpack_public_path__ + "src/assets/img/checkmark.27ce225e.svg";